import client from './client';
import { IUserLog, getRequestData, formatUserData, IBookLog } from './index';

export default (
    cid: string,
    user: IUserLog,
    book: Omit<IBookLog, 'status'>
) => {
    client.info('create account click', {
        cid,
        context: 'BetPlacePage#openAffiliateLink',
        book,
        ...formatUserData(user),
        ...getRequestData(),
    });
};
